const SkeletonLoading = ({ }) => {
    return (
        <div className="tw:bg-gradient-to-b tw:from-[#f6f6f6] tw:to-white tw:pb-8 tw:!pt-10">
            <div className="tw:mx-auto tw:max-w-[1300px] tw:px-6">
                {/* Header Section Skeleton */}
                <div className="tw:flex tw:flex-wrap tw:items-center tw:gap-6 tw:pb-[42px]">
                    <div className="tw:h-10 tw:w-24 tw:animate-pulse tw:rounded-[5px] tw:bg-gray-200" />
                    <div className="tw:flex tw:flex-col tw:gap-[6px]">
                        <div className="tw:h-4 tw:w-48 tw:animate-pulse tw:bg-gray-200" />
                        <div className="tw:h-8 tw:w-64 tw:animate-pulse tw:bg-gray-200" />
                    </div>
                </div>

                {/* Main Content Skeleton */}
                <div className="tw:flex tw:flex-col tw:gap-3 tw:lg:flex-row">
                    {/* Left Column Skeleton */}
                    <div className="tw:flex tw:flex-1 tw:flex-col tw:gap-3">
                        {[1, 2, 3, 4].map((i) => (
                            <div
                                key={i}
                                className="tw:rounded-[5px] tw:border tw:border-[#e8e8e8] tw:bg-white tw:px-7 tw:py-[30px]"
                            >
                                <div className="tw:mb-6 tw:h-6 tw:w-48 tw:animate-pulse tw:bg-gray-200" />
                                <div className="tw:h-px tw:w-full tw:bg-[#e8e8e8]" />
                                <div className="tw:flex tw:flex-col tw:gap-[14px] tw:pt-6">
                                    <div className="tw:flex tw:flex-wrap tw:gap-[54px]">
                                        <div className="tw:h-12 tw:w-[200px] tw:animate-pulse tw:bg-gray-200" />
                                        <div className="tw:h-12 tw:w-[200px] tw:animate-pulse tw:bg-gray-200" />
                                        <div className="tw:h-12 tw:w-[200px] tw:animate-pulse tw:bg-gray-200" />
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>

                    {/* Right Sidebar Skeleton */}
                    <div className="tw:flex tw:w-full tw:flex-col tw:gap-3 tw:lg:w-[340px]">
                        <div className="tw:h-[45px] tw:animate-pulse tw:rounded-[5px] tw:bg-gray-200" />
                        <div className="tw:h-[300px] tw:animate-pulse tw:rounded-[5px] tw:bg-gray-200" />
                        <div className="tw:h-[200px] tw:animate-pulse tw:rounded-[5px] tw:bg-gray-200" />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SkeletonLoading;
